import { render, staticRenderFns } from "./InsightsQuestions.vue?vue&type=template&id=fbd3084c"
import script from "./InsightsQuestions.vue?vue&type=script&lang=js"
export * from "./InsightsQuestions.vue?vue&type=script&lang=js"
import style0 from "./InsightsQuestions.vue?vue&type=style&index=0&id=fbd3084c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports